import { useSelector } from "react-redux"
import { selectUserDetails } from "../selectors/user"
import { useEffect, useState } from "react"
import StackTracey from "stacktracey"
import { logExceptions } from "../services/apis/misc"

const useErrorLog = (error: Error): boolean => {
	const [loading, setLoading] = useState(true)
    const userDetails = useSelector(selectUserDetails)

    const logException = (error: Error, timestamp: number, url: string) => {
		setLoading(true)
		console.error('error Log:', error, JSON.stringify(error), error.stack, typeof error.stack)
		if (error?.message?.includes("Loading chunk") || error?.name === "ChunkLoadError" || (!error?.name && !error?.message && (error.stack===''||!error.stack))) {
			setLoading(false)
			window.location.reload()
			return
		}
        if(import.meta.env.MODE !== 'production' || window?.location?.origin?.includes("localhost")) {
			setLoading(false)
			return
		}
        const errorMessage = {
            userId: userDetails?.currentUser?.id,
            userEmail: userDetails?.currentUser?.email,
            timestampAt: new Date().getTime(),
            url: url,
            errorMessage: error?.message,
            stackTrace: error?.stack,
        }
		if(!error?.stack) {
			errorMessage.stackTrace = `name: ${error?.name}, message: ${error?.message}, stack: ${error?.stack}`
		}
		setLoading(false)
		if(errorMessage.errorMessage) {
			errorMessage.errorMessage = errorMessage.errorMessage?.substring(0, 4000)
		}
		if(errorMessage.stackTrace) {
			errorMessage.stackTrace = errorMessage.stackTrace?.substring(0, 4000)
		}
        logExceptions(errorMessage)
    }

	useEffect(()=>{
		const timestamp = new Date().getTime()
		const url = window.location.href
		try{
			const stack = new StackTracey (error)
			stack.withSourcesAsync().then((response: StackTracey) => {
				const stackTrace = response.items.reduce((prevTrace: string, curr: StackTracey.Entry) => {
					const updatedTrace = `${prevTrace}at ${curr.callee} (${curr.file}:${curr.line}) ${curr.sourceLine?.trim()} \n  `
					return updatedTrace
				}, "")
				console.log("mapped stack trace", stackTrace)
				logException({...error, stack: stackTrace}, timestamp, url)
			})
		}catch(e){
			logException({...error, stack: error.stack ?? ''}, timestamp, url)
		}

	}, [error])
    return loading;
}

export default useErrorLog;